module.exports = __webpack_public_path__ + "img/account.b8d96f1d.jpg";